var Model = require('../Model');

var InstrumentCertificate = Object.create(Model);

InstrumentCertificate.name = 'InstrumentCertificate';
InstrumentCertificate['@class'] = 'InstrumentCertificate';
InstrumentCertificate.url = 'instrumentcertificate';
InstrumentCertificate.isMultipart = true;
InstrumentCertificate.fields = {
  instrument: {
  	default: null
  },
  originDate: {
    type: 'date',
    validators: {
      presence: true
    }
  },
  expirationDate: {
    type: 'date',
    validators: {
      presence: true
    }
  },
  description: {
    type: 'text',
    default: null,
    validators: { 
      length: {minimum: 1, maximum: 120, default: ''},
    }
  },
  equipmentId: {
    //type: 'text',
    default: null,
    hidden: true,
  },
  certificateNumber: {
    type: 'text',
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 120, default: ''},
    }
  },
  certificate: {
    name: 'certificate',
    type: 'file',
    validators: {
      presence: true
    }
  },
  createdOn: { },
  createdBy: { },
};

module.exports = InstrumentCertificate;
